import { MultipleChart } from "components";

import uniqolor from "uniqolor"
import { useList } from "../../utils";
import { DashboardFillType } from "types";

export function TotalUnits(props: {
    fill: DashboardFillType
}){

    const barList: string[] = ["Total Inbond", "Total Outbond"]

    const { data } = useList({
		date: `${props.fill.year}${props.fill.month}`,
		location_id: props.fill.location_id?.toString() || ""
	})


    return(
        <section className="flex flex-col border p-3 h-full">
            <div className="">
                <div className="text-center text-lg font-bold mb-3">Inbond vs. Outbond: Total Units</div>
                <MultipleChart
                    className="h-[350px]"
                    chartType="bar"
                    data={{
                        labels: ["Total Inbond", "Total Outbond"],
                        datasets: [
                            {
                                data: [
                                    Number(data?.totalUnit?.total_inbond ) ?? 0,
                                    Number(data?.totalUnit?.total_outbond ) ?? 0
                                  ],
                                backgroundColor: barList.map(() => uniqolor.random({ format: "rgb" }).color)
                            }
                        ]
                    }}
                />
            </div>
        </section>
    )
}